// extracted by mini-css-extract-plugin
export default {"container":"HowToVideo_container__LO3zD","video":"HowToVideo_video__SHPV5"};